import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { ChartOfAccountsTable } from '../../../../../../../../../../features/accounting/chart-of-accounts/chart-of-accounts-table';
import { CreateChartOfAccountsAccountDrawer } from '../../../../../../../../../../features/accounting/chart-of-accounts/create-chart-of-account-account-drawer';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/account/_account/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceAccounting,
      label: 'Chart of Accounts',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceAccounting>,
  head: () => getPageHead('Chart of Accounts'),
  component: ChartOfAccountList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateChartOfAccountsAccountDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Account" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinanceAccounting}
    />
  );
}

function ChartOfAccountList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ChartOfAccountsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
